import React, { useEffect, useState, useRef } from "react";
import { decodeToken } from "../../utils/commonFunctions";
import {
  SidebarTitle,
  DeleteConversations,
  TitleUpdate,
} from "../../utils/Chatapi";
import { useChatContext } from "../../context/ChatContext";
import { Box, Tooltip } from "@mui/material";

import "../Home/homestyle.css";
import Edit from "../../assets/images/edit.png";
import Adding from "../../assets/images/Adding.png";
import Books from "../../assets/images/book.png";
import Dashboard from "../../assets/images/dashboard.png";
import Sdesign from "../../assets/images/Sdesign.png";
import Kdesign from "../../assets/images/Kdesign.png";
import Search from "../../assets/images/search-icon.png";
import { useNavigate } from "react-router-dom";
import { SchoolSignupContext } from "../../context/SchoolSignupContext";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import { SidebarTitle ,DeleteConversations,TitleUpdate} from "../../utils/Chatapi";

// Project theme tooltip styling (#2C68A1)
const tooltipSlotProps = {
  tooltip: {
    sx: {
      backgroundColor: "rgba(44, 104, 161, 1)",
      color: "#fff",
      fontSize: "13px",
      fontWeight: 500,
    },
  },
};

const SideBar1 = () => {
  const userTokenData = decodeToken();
  const userId = userTokenData?.user_id;
  const masterTypeid = userTokenData?.masterTypeid;
  const isTft = masterTypeid == 1;

  const navigate = useNavigate()
  const [searchValue, setSearchValue] = useState("")
  const { signupData, setSignupData } = React.useContext(SchoolSignupContext);
    const token = localStorage.getItem("access_token");


  const {
    titleId,
    setTitleId,
    setInitialStart,
    sidelistUpdate,
    setSidelistUpdate,
    initialStart,
    highLightBtn, setHighLightBtn,
    conversationHistory,
    setConversationHistory,
  } = useChatContext();
  const [open1, setOpen1] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [open3, setOpen3] = useState(false);
  const [open4, setOpen4] = useState(false);
  const [scrollInProgress, setScrollInProgress] = useState(false);
  const scrollTimeoutRef = useRef(null);

  const toggleSidebar = (forceOpen) => {
    let sidebar = document.getElementById("sidebar");
    let content = document.getElementById("content");
    let header = document.getElementById("header");

    if (forceOpen) {
      sidebar?.classList.add("open");
      content?.classList.add("shrink");
      header?.classList.add("shrink");
    } else {
      sidebar?.classList.toggle("open");
      content?.classList.toggle("shrink");
      header?.classList.toggle("shrink");
    }
  };

  useEffect(() => {
    if (userTokenData?.email) {
      toggleSidebar(true);
    } else {
      let sidebar = document.getElementById("sidebar");
      let content = document.getElementById("content");
      let header = document.getElementById("header");

      sidebar?.classList.remove("open");
      content?.classList.remove("shrink");
      header?.classList.remove("shrink");
    }
  }, [userTokenData?.email, initialStart]);



  useEffect(() => {
    if (userId == null || userId === undefined) return;
    SidebarTitle(userId, setConversationHistory, searchValue);
  }, [userId, sidelistUpdate, searchValue]);


  const handleClick = (label, title_id, type) => {
    navigate(`/afterchatbot?id=${title_id}`);
    setTitleId(title_id);
    setInitialStart(type);
    setHighLightBtn(type);
  };

  const handleNewGenerate = () => {
    // localStorage.setItem("titleId", "");
    sessionStorage.setItem("titleId", "");
    setTitleId("");
    setInitialStart("LearningSupports")
    setHighLightBtn(false)
    navigate("/")
  };
  const handleSearch = (e) => {
    setSearchValue(e.target.value)
  }

  function handleLockedClick() {
    toast.info("🔒 This feature is locked. It will be released soon.");
  }

  const handleScroll = () => {
    setScrollInProgress(true);
    if (scrollTimeoutRef.current) clearTimeout(scrollTimeoutRef.current);
    scrollTimeoutRef.current = setTimeout(() => setScrollInProgress(false), 400);
  };

  useEffect(() => {
    return () => {
      if (scrollTimeoutRef.current) clearTimeout(scrollTimeoutRef.current);
    };
  }, []);


  useEffect(() => {
    conversationHistory?.forEach((item) => {
      if (!item?.title || item?.title?.trim() === '' || item?.title === 'testing one two') {
        DeleteConversations(item?.id, setSidelistUpdate);
      }
    });
  }, [conversationHistory]);

  return (
    <div className="sidebar-content-other">
      <div className="sidebar sidebar-one open" id="sidebar">
        <div className="sidebar-inner-image">
          {/* <h2>School Name </h2> */}
          <h2>{signupData.schoolName || "School Name"}</h2>


          <Tooltip title="Toggle sidebar" placement="right" slotProps={tooltipSlotProps} disableHoverListener={scrollInProgress} disableFocusListener={scrollInProgress} open={scrollInProgress ? false : undefined}>
            <img
              className="dashboard-btn menu-icon"
              onClick={() => toggleSidebar()}
              src={Dashboard}
              alt="Toggle Sidebar"
            />
          </Tooltip>
        </div>

        <div className="sidebar-inner-layout">
          <img className="search-icon" src={Search} alt="Search" />
          <input
            type="text"
            placeholder="Search"
            value={searchValue}
            onChange={handleSearch}
          />
        </div>

        {isTft ? (
          <div className="generate-outer">
            <div className="generate-inner" onClick={handleNewGenerate}>
              <img className="adding-icon" src={Adding} alt="" />
              <h2>New Chat</h2>
            </div>
          </div>
        ) : (
          <div className="generate-outer">
            <div className="generate-inner" onClick={handleNewGenerate}>
              <img className="adding-icon" src={Adding} alt="" />
              <h2>Home</h2>
            </div>
          </div>
        )}

        {/* <div className="generate-outer"
        >
          <div className="generate-inner"
            // style={{ border: "1px solid black" }
            onClick={handleNewGenerate}
          >
            <img className="adding-icon" src={Adding} />
            <h2>Home</h2>
          </div>
        </div> */}




{isTft ?


//======================
        <div className="ScrollBar" onScroll={handleScroll}>
          {/* Collapsible Section 1 */}
          <div className="sidebar-up-down">
            {/* <div className="books-colla"
              onClick={() => setOpen1(!open1)}
            >
              <img src={Books} alt="Books Icon" />
              <h3
                className="collapsible"
              >
                Full Unit Plans
              </h3>
            </div> */}

            {conversationHistory && (
              
              <Box>
                {conversationHistory
                  // .filter(item => item.question === "UnitPlanning")
                  .map((item, index) => {
                    const cleanTitle = item?.title?.replace(/"/g, '');
                    const veryLightGrey = '#f9f9f9';
                    const lightGrey = '#e0e0e0';

                    const showTooltip = !!(cleanTitle && cleanTitle.length > 30);
                    return (
                      <Tooltip
                        key={index}
                        title={showTooltip ? (cleanTitle || item?.title || "") : ""}
                        placement="right"
                        slotProps={tooltipSlotProps}
                        open={scrollInProgress ? false : undefined}
                        disableHoverListener={!showTooltip}
                        disableFocusListener={!showTooltip}
                      >
                        <Box
                          className="contents full-unit"
                          sx={{
                            color: 'black',
                            padding: 1,
                            cursor: 'pointer'
                          }}
                          onClick={() => handleClick(item?.title, item?.id, item?.question)}
                        >
                          {cleanTitle?.length > 30 ? cleanTitle.substring(0, 30) + "..." : cleanTitle}
                        </Box>
                      </Tooltip>
                    );
                  })}
              </Box>




            )}


          </div>

         

          
        </div>

//======================

:
        <div className="ScrollBar" onScroll={handleScroll}>
          {/* Collapsible Section 1 - Unit Plan history commented out */}
          {/* <div className="sidebar-up-down">
            <div className="books-colla"
              onClick={() => setOpen1(!open1)}
            >
              <img src={Books} alt="Books Icon" />
              <h3
                className="collapsible"
              >
                Full Unit Plans
              </h3>
            </div>

            {open1 && conversationHistory && (
              
              <Box>
                {conversationHistory
                  .filter(item => item.question === "UnitPlanning")
                  .map((item, index) => {
                    const cleanTitle = item?.title?.replace(/"/g, '');
                    const veryLightGrey = '#f9f9f9';
                    const lightGrey = '#e0e0e0';

                    const showTooltip = !!(cleanTitle && cleanTitle.length > 30);
                    return (
                      <Tooltip
                        key={index}
                        title={showTooltip ? (cleanTitle || item?.title || "") : ""}
                        placement="right"
                        slotProps={tooltipSlotProps}
                        open={scrollInProgress ? false : undefined}
                        disableHoverListener={!showTooltip}
                        disableFocusListener={!showTooltip}
                      >
                        <Box
                          className="contents full-unit"
                          sx={{
                            color: 'black',
                            padding: 1,
                            cursor: 'pointer'
                          }}
                          onClick={() => handleClick(item?.title, item?.id, item?.question)}
                        >
                          {cleanTitle?.length > 30 ? cleanTitle.substring(0, 30) + "..." : cleanTitle}
                        </Box>
                      </Tooltip>
                    );
                  })}
              </Box>




            )}


          </div> */}

          {/* Collapsible Section 2 - Lesson Plan history commented out */}
          {/* <div className="sidebar-up-down">
            <div className="books-colla"
              onClick={() => setOpen2(!open2)}
            >
              <img src={Books} alt="Books Icon" />
              <h3
                className="collapsible"
              >
                Lesson Plans
              </h3>
            </div>

            {open2 && conversationHistory && (
              <div className="contents">

                {conversationHistory
                  .filter(item => item.question === "LessonPlanning")
                  .map((item, index) => {
                    const cleanTitle = item?.title?.replace(/"/g, '');
                    const veryLightGrey = '#f9f9f9';
                    const lightGrey = '#e0e0e0';

                    const showTooltip = !!(cleanTitle && cleanTitle.length > 30);
                    return (
                      <Tooltip
                        key={index}
                        title={showTooltip ? (cleanTitle || item?.title || "") : ""}
                        placement="right"
                        slotProps={tooltipSlotProps}
                        open={scrollInProgress ? false : undefined}
                        disableHoverListener={!showTooltip}
                        disableFocusListener={!showTooltip}
                      >
                        <div
                          className="contents full-unit"
                          style={{
                            color: 'black',
                            padding: '5px',
                            cursor: 'pointer'
                          }}
                          onClick={() => handleClick(item?.title, item?.id, item?.question)}
                        >
                          {cleanTitle?.length > 30 ? cleanTitle.substring(0, 30) + "..." : cleanTitle}
                        </div>
                      </Tooltip>
                    );
                  })}



              </div>
            )}
          </div> */}


          <div className="sidebar-up-down">
            <div className="books-colla"
              onClick={() => setOpen3(!open3)}

              // onClick={handleLockedClick}
            >
              <img src={Books} alt="Books Icon" />
              <h3
                className="collapsible"
              >
                Learning Support
              </h3>
            </div>
            {
            // open3 && 
            conversationHistory && (
              <div className="contents">

                {conversationHistory.filter(item => item.question == "LearningSupports")
                  .map((item, index) => {
                    const cleanTitle = item?.title?.replace(/"/g, '');
                    const showTooltip = !!(cleanTitle && cleanTitle.length > 30);
                    return (
                      <Tooltip
                        key={index}
                        title={showTooltip ? (cleanTitle || item?.title || "") : ""}
                        placement="right"
                        slotProps={tooltipSlotProps}
                        open={scrollInProgress ? false : undefined}
                        disableHoverListener={!showTooltip}
                        disableFocusListener={!showTooltip}
                      >
                        <div
                          style={{
                            color: 'black',
                            padding: '5px',
                            cursor: 'pointer'
                          }}
                          className="contents full-unit"
                          onClick={() => handleClick(item?.title, item?.id, item?.question)}
                        >
                          {cleanTitle?.length > 30 ? cleanTitle.substring(0, 30) + "..." : cleanTitle}
                        </div>
                      </Tooltip>
                    );
                  })}

              </div>
            )}
          </div> 



          {/* Collapsible Section 4 */}
          {/* <div className="sidebar-up-down">
            <div className="books-colla"
              onClick={() => setOpen4(!open4)}
            >
              <img src={Books} alt="Books Icon" />
              <h3
                className="collapsible"
              >
                Assessments
              </h3>
            </div>
            {open4 && conversationHistory && (
              <div className="contents ">


                <Box>
                  {conversationHistory
                    .filter(item => item.question === "Assessment")
                    .map((item, index) => {
                      const cleanTitle = item?.title?.replace(/"/g, '');
                      const veryLightGrey = '#f9f9f9';
                      const lightGrey = '#e0e0e0';

                      return (
                        <Box
                          key={index}
                          className="contents full-unit"
                          sx={{
                            // backgroundColor: index % 2 === 0 ? veryLightGrey : lightGrey,
                            color: 'black',
                            padding: 1,
                            cursor: 'pointer'
                          }}
                          onClick={() => handleClick(item?.title, item?.id, item?.question)}
                        >
                          {cleanTitle?.length > 30 ? cleanTitle.substring(0, 30) + "..." : cleanTitle}
                        </Box>
                      );
                    })}
                </Box>


              </div>
            )}
          </div> */}
        </div>
}       

      </div>
    </div>
  );
};

export default SideBar1;
